module.exports = __webpack_public_path__ + "img/result-detail-invest-outleft03.fd95bec2.svg";